jQuery( document ).ready(function($) {
    $("input[name='customization_text']").bind("change paste keyup", function() {
        const value = $("input[name='customization_text']").val()
        if(value === ""){
          $("#customization").val("none")
        }
        else{
            $("#customization").val(value);  //$("input[name='customization']").val()
        }
    });
});